"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Axis = _interopRequireDefault(require("./Axis"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Axes extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderAxis", (position, index) => {
      const _this$props = this.props,
            xScale = _this$props.xScale,
            yScale = _this$props.yScale,
            width = _this$props.width,
            height = _this$props.height,
            top = _this$props.top,
            right = _this$props.right,
            bottom = _this$props.bottom,
            left = _this$props.left;
      const axis = this.props[position];
      if (!axis) return null;
      const isXAxis = position === 'top' || position === 'bottom';
      const ticksPosition = position === 'top' || position === 'left' ? 'before' : 'after';
      return _react.default.createElement(_Axis.default, _extends({
        key: position
      }, axis, {
        axis: isXAxis ? 'x' : 'y',
        position: position,
        x: position === 'right' ? width : 0,
        y: position === 'bottom' ? height : 0,
        scale: isXAxis ? xScale : yScale,
        length: isXAxis ? width : height,
        ticksPosition: ticksPosition
      }));
    });
  }

  render() {
    const positions = ['top', 'right', 'bottom', 'left'];
    return _react.default.createElement("g", {
      className: "axes"
    }, positions.map(this.renderAxis));
  }

}

var _default = Axes;
exports.default = _default;
module.exports = exports.default;